module.exports = __webpack_public_path__ + "static/media/1.15127ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/slides/1.png
// module id = 250
// module chunks = 0